import { CASHOUT_BLOCK_LIST_RECEIVED, CASHOUT_BLOCK_MARKET_TEMPLATE } from '../types';

const initialState = {
    blockedEvents: [],

    blockedMarketsList: [],
};

const cashoutBlock = (state = initialState, action) => {
    switch (action.type) {
        case CASHOUT_BLOCK_LIST_RECEIVED:
            return {
                ...state,
                blockedEvents: action.payload,
            };

        case CASHOUT_BLOCK_MARKET_TEMPLATE: {
            return {
                ...state,
                blockedMarketsList: action.payload,
            };
        }

        default:
            return state;
    }
};

export default cashoutBlock;
